import { requestFailureReport, serializeErrorReport } from '../shared/error-report.js';
import type { SchemaInput } from '../shared/schema-input.js';
import { requestErrorDetails, stagedRequestErrorDetails, type RequestFailureContext } from '../shared/request-error.js';
import { trackPageEvent } from './page-analytics.js';

export function reportRequestFailure(error: SchemaInput, operation: string, context?: RequestFailureContext): void {
  const details = context ? stagedRequestErrorDetails(error, context) : requestErrorDetails(error);
  if (!context && !details.operation && !details.cause_type) return;
  trackPageEvent('map', 'console_error', {
    error_blob: serializeErrorReport({ ...requestFailureReport(error), kind: 'request_failure', ...details,
      operation: details.operation ?? operation, source: details.operation ?? operation }),
  });
}
